import {Injectable, OnDestroy} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {User} from '../services/user/user';
import {ISubscription} from 'rxjs-compat/Subscription';
import {UserService} from '../services/user/user.service';
import AppConstants from '../shared/common-components/AppConstants';

@Injectable()
export class AdminGuard  implements OnDestroy {

    currentUser: User;
    private user_subscription: ISubscription;

    constructor(private router: Router, private userService: UserService) {
        // this method is used to get the user details, instead of calling to server every time, by using behavioural subject
        this.user_subscription =  this.userService.getCurrentUserObservable().subscribe(currentUser => {
            this.currentUser = currentUser;
        }, (error) => {
            console.log(error);
        });
    }

    /**
     * This guard is for Admins, i.e, Agency Admin, Carrier User Admin, System Admin
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const allowedRoles =  AppConstants.getAdminRolesArray();
        if (!this.isLoggedIn()) {
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        }
        const userRoles = Array.from(this.currentUser.roles, x => x.role);
        if (userRoles && userRoles.length > 0) {
            // check if any of the user roles match the allowed roles
            const found = userRoles.some(role => allowedRoles.indexOf(role) >= 0);
            if (found) {
                return true;
            } else {
                // redirecting user to 404 page if user is not allowed to access the page
                this.router.navigate(['/404'], { queryParams: { returnUrl: state.url }});
                return false;
            }
        } else {
            this.router.navigate(['/404'], { queryParams: { returnUrl: state.url }});
            return false;
        }
    }

    /**
     * destroying the subscription
     */
    ngOnDestroy(): void {
        this.user_subscription.unsubscribe();
    }

    /**
     * checking if user is logged in
     */
    isLoggedIn() {
        return this.currentUser !== null && this.currentUser !== undefined  && this.currentUser.id !== null && this.currentUser.id !== undefined;
    }
}
